<template>
  <div class="policy-container">
    <div class="policy-header">
      <div class="policy-title">
        <h1 class="title">{{ $t('legal.privacy.paragraph_001') }}</h1>
      </div>
    </div>
    <div class="policy-content mt-2vw">
      <p class="update-date" style="color: #aaa;">{{ $t('legal.privacy.paragraph_002') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_003') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_004') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_005') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_006') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_007') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_008') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_009') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_010') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_011') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_012') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_013') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_014') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_015') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_016') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_017') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_018') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_019') }}<br/>{{ $t('legal.privacy.paragraph_020') }}<br/>{{ $t('legal.privacy.paragraph_021') }}<br/>{{ $t('legal.privacy.paragraph_022') }}<br/>{{ $t('legal.privacy.paragraph_023') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_024') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_025') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_026') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_027') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_028') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_029') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_030') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_031') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_032') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_033') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_034') }}<br/>{{ $t('legal.privacy.paragraph_035') }}<br/>{{ $t('legal.privacy.paragraph_036') }}<br/>{{ $t('legal.privacy.paragraph_037') }}<br/>{{ $t('legal.privacy.paragraph_038') }}<br/>{{ $t('legal.privacy.paragraph_039') }}<br/>{{ $t('legal.privacy.paragraph_040') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_041') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_042') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_043') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_044') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_045') }}<br/>{{ $t('legal.privacy.paragraph_046') }}<br/>{{ $t('legal.privacy.paragraph_047') }}<br/>{{ $t('legal.privacy.paragraph_048') }}<br/>{{ $t('legal.privacy.paragraph_049') }}<br/>{{ $t('legal.privacy.paragraph_050') }}<br/>{{ $t('legal.privacy.paragraph_051') }}<br/>{{ $t('legal.privacy.paragraph_052') }}<br/>{{ $t('legal.privacy.paragraph_053') }}<br/>{{ $t('legal.privacy.paragraph_054') }}<br/>{{ $t('legal.privacy.paragraph_055') }}<br/>{{ $t('legal.privacy.paragraph_056') }}<br/>{{ $t('legal.privacy.paragraph_057') }}<br/>{{ $t('legal.privacy.paragraph_058') }}<br/>{{ $t('legal.privacy.paragraph_059') }}<br/>{{ $t('legal.privacy.paragraph_060') }}<br/>{{ $t('legal.privacy.paragraph_061') }}<br/>{{ $t('legal.privacy.paragraph_062') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_063') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_064') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_065') }}<br/>{{ $t('legal.privacy.paragraph_066') }}<br/>{{ $t('legal.privacy.paragraph_067') }}<br/>{{ $t('legal.privacy.paragraph_068') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_069') }}</p>
      <div class="policy-table">
        <table class="policy-table-content">
          <thead class="ant-table-thead">
            <tr>
              <th class="column-w-50">
                <span class="ant-table-header-column">
                  <span class="ant-table-column-title">{{ $t('legal.privacy.paragraph_070') }}</span>
                </span>
              </th>
              <th class="column-w-25">
                <span class="ant-table-header-column">
                  <span class="ant-table-column-title">{{ $t('legal.privacy.paragraph_071') }}</span>
                </span>
              </th>
              <th class="column-w-25">
                <span class="ant-table-header-column">
                  <span class="ant-table-column-title">{{ $t('legal.privacy.paragraph_072') }}</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody class="ant-table-tbody">
            <tr class="ant-table-row ant-table-row-level-0">
              <td colspan="3">
                <p class="table-font-bold">{{ $t('legal.privacy.paragraph_073') }}</p>
              </td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_074') }}<br/>{{ $t('legal.privacy.paragraph_075') }}<br/>{{ $t('legal.privacy.paragraph_076') }}<br/>{{ $t('legal.privacy.paragraph_077') }}<br/>{{ $t('legal.privacy.paragraph_078') }}<br/>{{ $t('legal.privacy.paragraph_079') }}<br/>{{ $t('legal.privacy.paragraph_080') }}<br/>{{ $t('legal.privacy.paragraph_081') }}</td>
              <td>{{ $t('legal.privacy.paragraph_082') }}<br/>{{ $t('legal.privacy.paragraph_083') }}<br/>{{ $t('legal.privacy.paragraph_084') }}</td>
              <td>{{ $t('legal.privacy.paragraph_085') }}<br/>{{ $t('legal.privacy.paragraph_086') }}<br/>{{ $t('legal.privacy.paragraph_087') }}<br/>{{ $t('legal.privacy.paragraph_088') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td colspan="3">
                <p class="table-font-bold">{{ $t('legal.privacy.paragraph_089') }}</p>
              </td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_090') }}<br/>{{ $t('legal.privacy.paragraph_091') }}<br/>{{ $t('legal.privacy.paragraph_092') }}<br/>{{ $t('legal.privacy.paragraph_093') }}</td>
              <td>{{ $t('legal.privacy.paragraph_082') }}<br/>{{ $t('legal.privacy.paragraph_083') }}<br/>{{ $t('legal.privacy.paragraph_084') }}</td>
              <td>{{ $t('legal.privacy.paragraph_085') }}<br/>{{ $t('legal.privacy.paragraph_086') }}<br/>{{ $t('legal.privacy.paragraph_087') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td colspan="3">
                <p class="table-font-bold">{{ $t('legal.privacy.paragraph_094') }}</p>
              </td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_095') }}<br/>{{ $t('legal.privacy.paragraph_096') }}<br/>{{ $t('legal.privacy.paragraph_097') }}<br/>{{ $t('legal.privacy.paragraph_098') }}<br/>{{ $t('legal.privacy.paragraph_099') }}<br/>{{ $t('legal.privacy.paragraph_100') }}<br/>{{ $t('legal.privacy.paragraph_101') }}</td>
              <td>{{ $t('legal.privacy.paragraph_082') }}<br/>{{ $t('legal.privacy.paragraph_083') }}<br/>{{ $t('legal.privacy.paragraph_084') }}</td>
              <td>{{ $t('legal.privacy.paragraph_102') }}<br/>{{ $t('legal.privacy.paragraph_087') }}<br/>{{ $t('legal.privacy.paragraph_085') }}<br/>{{ $t('legal.privacy.paragraph_088') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td colspan="3">
                <p class="table-font-bold">{{ $t('legal.privacy.paragraph_103') }}</p>
              </td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_104') }}<br/>{{ $t('legal.privacy.paragraph_105') }}<br/>{{ $t('legal.privacy.paragraph_106') }}<br/>{{ $t('legal.privacy.paragraph_107') }}</td>
              <td>{{ $t('legal.privacy.paragraph_082') }}<br/>{{ $t('legal.privacy.paragraph_083') }}<br/>{{ $t('legal.privacy.paragraph_084') }}</td>
              <td>{{ $t('legal.privacy.paragraph_085') }}<br/>{{ $t('legal.privacy.paragraph_108') }}<br/>{{ $t('legal.privacy.paragraph_088') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td colspan="3">
                <p class="table-font-bold">{{ $t('legal.privacy.paragraph_109') }}</p>
              </td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_110') }}<br/>{{ $t('legal.privacy.paragraph_111') }}<br/>{{ $t('legal.privacy.paragraph_112') }}<br/>{{ $t('legal.privacy.paragraph_113') }}<br/>{{ $t('legal.privacy.paragraph_114') }}<br/>{{ $t('legal.privacy.paragraph_115') }}</td>
              <td>{{ $t('legal.privacy.paragraph_082') }}<br/>{{ $t('legal.privacy.paragraph_083') }}<br/>{{ $t('legal.privacy.paragraph_084') }}</td>
              <td>{{ $t('legal.privacy.paragraph_116') }}<br/>{{ $t('legal.privacy.paragraph_117') }}<br/>{{ $t('legal.privacy.paragraph_085') }}<br/>{{ $t('legal.privacy.paragraph_086') }}<br/>{{ $t('legal.privacy.paragraph_118') }}<br/>{{ $t('legal.privacy.paragraph_088') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td colspan="3">
                <p class="table-font-bold">{{ $t('legal.privacy.paragraph_119') }}</p>
              </td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_120') }}<br/>{{ $t('legal.privacy.paragraph_121') }}<br/>{{ $t('legal.privacy.paragraph_122') }}</td>
              <td>{{ $t('legal.privacy.paragraph_123') }}<br/>{{ $t('legal.privacy.paragraph_082') }}<br/>{{ $t('legal.privacy.paragraph_083') }}<br/>{{ $t('legal.privacy.paragraph_084') }}</td>
              <td>{{ $t('legal.privacy.paragraph_086') }}<br/>{{ $t('legal.privacy.paragraph_124') }}<br/>{{ $t('legal.privacy.paragraph_125') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_126') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_127') }}</p>
      <div class="policy-table">
        <table class="policy-table-content">
          <thead class="ant-table-thead">
            <tr>
              <th class="column-w-25">
                <span class="ant-table-header-column">
                  <span class="ant-table-column-title">{{ $t('legal.privacy.paragraph_128') }}</span>
                </span>
              </th>
              <th class="column-w-25">
                <span class="ant-table-header-column">
                  <span class="ant-table-column-title">{{ $t('legal.privacy.paragraph_129') }}</span>
                </span>
              </th>
              <th class="column-w-50">
                <span class="ant-table-header-column">
                  <span class="ant-table-column-title">{{ $t('legal.privacy.paragraph_130') }}</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody class="ant-table-tbody">
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_131') }}</td>
              <td>{{ $t('legal.privacy.paragraph_132') }}</td>
              <td>{{ $t('legal.privacy.paragraph_133') }}<br/>{{ $t('legal.privacy.paragraph_134') }}<br/>{{ $t('legal.privacy.paragraph_135') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_136') }}</td>
              <td>{{ $t('legal.privacy.paragraph_137') }}</td>
              <td>{{ $t('legal.privacy.paragraph_138') }}<br/>{{ $t('legal.privacy.paragraph_139') }}<br/>{{ $t('legal.privacy.paragraph_140') }}<br/>{{ $t('legal.privacy.paragraph_141') }}<br/>{{ $t('legal.privacy.paragraph_142') }}<br/>{{ $t('legal.privacy.paragraph_143') }}<br/>{{ $t('legal.privacy.paragraph_144') }}<br/>{{ $t('legal.privacy.paragraph_145') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_146') }}</td>
              <td>{{ $t('legal.privacy.paragraph_147') }}</td>
              <td>{{ $t('legal.privacy.paragraph_148') }}<br/>{{ $t('legal.privacy.paragraph_149') }}<br/>{{ $t('legal.privacy.paragraph_150') }}<br/>{{ $t('legal.privacy.paragraph_151') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_152') }}</td>
              <td>{{ $t('legal.privacy.paragraph_153') }}</td>
              <td>{{ $t('legal.privacy.paragraph_138') }}<br/>{{ $t('legal.privacy.paragraph_139') }}<br/>{{ $t('legal.privacy.paragraph_140') }}<br/>{{ $t('legal.privacy.paragraph_141') }}<br/>{{ $t('legal.privacy.paragraph_142') }}<br/>{{ $t('legal.privacy.paragraph_143') }}<br/>{{ $t('legal.privacy.paragraph_144') }}<br/>{{ $t('legal.privacy.paragraph_154') }}<br/>{{ $t('legal.privacy.paragraph_155') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_156') }}</td>
              <td>{{ $t('legal.privacy.paragraph_157') }}</td>
              <td>{{ $t('legal.privacy.paragraph_158') }}<br/>{{ $t('legal.privacy.paragraph_159') }}<br/>{{ $t('legal.privacy.paragraph_160') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_161') }}</td>
              <td>{{ $t('legal.privacy.paragraph_162') }}</td>
              <td>{{ $t('legal.privacy.paragraph_159') }}<br/>{{ $t('legal.privacy.paragraph_155') }}<br/>{{ $t('legal.privacy.paragraph_163') }}<br/>{{ $t('legal.privacy.paragraph_164') }}<br/>{{ $t('legal.privacy.paragraph_165') }}<br/>{{ $t('legal.privacy.paragraph_166') }}<br/>{{ $t('legal.privacy.paragraph_167') }}<br/>{{ $t('legal.privacy.paragraph_160') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_168') }}</td>
              <td>{{ $t('legal.privacy.paragraph_169') }}</td>
              <td>{{ $t('legal.privacy.paragraph_170') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_171') }}</td>
              <td>{{ $t('legal.privacy.paragraph_172') }}</td>
              <td>{{ $t('legal.privacy.paragraph_138') }}<br/>{{ $t('legal.privacy.paragraph_139') }}<br/>{{ $t('legal.privacy.paragraph_140') }}<br/>{{ $t('legal.privacy.paragraph_141') }}<br/>{{ $t('legal.privacy.paragraph_142') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_173') }}</td>
              <td>{{ $t('legal.privacy.paragraph_174') }}</td>
              <td>{{ $t('legal.privacy.paragraph_175') }}<br/>{{ $t('legal.privacy.paragraph_176') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_177') }}</td>
              <td>{{ $t('legal.privacy.paragraph_178') }}</td>
              <td>{{ $t('legal.privacy.paragraph_135') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_179') }}</td>
              <td>{{ $t('legal.privacy.paragraph_180') }}</td>
              <td>{{ $t('legal.privacy.paragraph_181') }}<br/>{{ $t('legal.privacy.paragraph_182') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_183') }}</td>
              <td>{{ $t('legal.privacy.paragraph_184') }}</td>
              <td>{{ $t('legal.privacy.paragraph_185') }}<br/>{{ $t('legal.privacy.paragraph_186') }}<br/>{{ $t('legal.privacy.paragraph_187') }}<br/>{{ $t('legal.privacy.paragraph_188') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_189') }}</td>
              <td>{{ $t('legal.privacy.paragraph_190') }}</td>
              <td>{{ $t('legal.privacy.paragraph_191') }}<br/>{{ $t('legal.privacy.paragraph_192') }}</td>
            </tr>
            <tr class="ant-table-row ant-table-row-level-0">
              <td>{{ $t('legal.privacy.paragraph_193') }}</td>
              <td>{{ $t('legal.privacy.paragraph_194') }}</td>
              <td>{{ $t('legal.privacy.paragraph_195') }}<br/>{{ $t('legal.privacy.paragraph_182') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_196') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_197') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_198') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_045') }}<br/>{{ $t('legal.privacy.paragraph_046') }}<br/>{{ $t('legal.privacy.paragraph_047') }}<br/>{{ $t('legal.privacy.paragraph_048') }}<br/>{{ $t('legal.privacy.paragraph_049') }}<br/>{{ $t('legal.privacy.paragraph_050') }}<br/>{{ $t('legal.privacy.paragraph_199') }}<br/>{{ $t('legal.privacy.paragraph_200') }}<br/>{{ $t('legal.privacy.paragraph_052') }}<br/>{{ $t('legal.privacy.paragraph_201') }}<br/>{{ $t('legal.privacy.paragraph_054') }}<br/>{{ $t('legal.privacy.paragraph_055') }}<br/>{{ $t('legal.privacy.paragraph_056') }}<br/>{{ $t('legal.privacy.paragraph_057') }}<br/>{{ $t('legal.privacy.paragraph_202') }}<br/>{{ $t('legal.privacy.paragraph_203') }}<br/>{{ $t('legal.privacy.paragraph_204') }}<br/>{{ $t('legal.privacy.paragraph_058') }}<br/>{{ $t('legal.privacy.paragraph_059') }}<br/>{{ $t('legal.privacy.paragraph_060') }}<br/>{{ $t('legal.privacy.paragraph_061') }}<br/>{{ $t('legal.privacy.paragraph_062') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_205') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_206') }}<br/>{{ $t('legal.privacy.paragraph_207') }}<br/>{{ $t('legal.privacy.paragraph_208') }}<br/>{{ $t('legal.privacy.paragraph_209') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_210') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_211') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_212') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_213') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_214') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_215') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_216') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_217') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_218') }}<br/>{{ $t('legal.privacy.paragraph_219') }}<br/>{{ $t('legal.privacy.paragraph_220') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_221') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_222') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_223') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_224') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_225') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_226') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_227') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_228') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_229') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_230') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_231') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_232') }}<br/>{{ $t('legal.privacy.paragraph_233') }}<br/>{{ $t('legal.privacy.paragraph_234') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_235') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_236') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_237') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_238') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_239') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_240') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_241') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_242') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_243') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_244') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_245') }}<br/>{{ $t('legal.privacy.paragraph_246') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_247') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_248') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_249') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_250') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_251') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_252') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_253') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_254') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_255') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_256') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_257') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_258') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_259') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_260') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_261') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_262') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_263') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_264') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_265') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_266') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_267') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_268') }}<br/>{{ $t('legal.privacy.paragraph_269') }}<br/>{{ $t('legal.privacy.paragraph_270') }}<br/>{{ $t('legal.privacy.paragraph_271') }}<br/>{{ $t('legal.privacy.paragraph_272') }}<br/>{{ $t('legal.privacy.paragraph_273') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_274') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_275') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_276') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_277') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_278') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_279') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_280') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_281') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_282') }}<br/>{{ $t('legal.privacy.paragraph_283') }}<br/>{{ $t('legal.privacy.paragraph_284') }}<br/>{{ $t('legal.privacy.paragraph_285') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_286') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_287') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_288') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_289') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_290') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_291') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_292') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_293') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_294') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_295') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_296') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_297') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_298') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_299') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_300') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_301') }}</p>
    </div>
    <div class="policy-content mb-4vw">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.privacy.paragraph_302') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_303') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_304') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.privacy.paragraph_305') }}</p>

    </div>
    <div class="policy-content mb-4vw">
      <div class="title-border"></div>

        <p class="policy-text">{{ $t('legal.privacy.paragraph_306') }}<br>
      <br>{{ $t('legal.privacy.paragraph_307') }}<br>{{ $t('legal.privacy.paragraph_308') }}<br>{{ $t('legal.privacy.paragraph_309') }}<br>{{ $t('legal.privacy.paragraph_310') }}<br>{{ $t('legal.privacy.paragraph_311') }}<a class="underline" href=" https://www.privacy.org.nz">{{ $t('legal.privacy.paragraph_312') }}</a>
    </p>
    </div>
  </div>
</template>

<script>

export default {
  components: {}
}
</script>

<style scoped>
.policy-container {
  padding: 6vh 0 0;
}
.policy-header {
  padding: 11vh 0 8vh 0;
  background-color: #163257;
}
.policy-title {
  padding: 1rem 5rem;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}
.title {
  font-size: 52px;
  text-align: left;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 56px;
  margin-top: 20px;
  width: 100%;
  text-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3);
}
.policy-content {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  padding: 2rem 5rem 1rem 5rem;
}
.policy-content-title {
  font-size: 28px;
  font-weight: 500;
  color: #163257;
  line-height: 30px;
}
.title-border {
  padding-bottom: 20px;
  width: 70px;
  border-top: 4px solid #f1dba8;
}
.policy-text {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
}
.subTitle {
  width: 862px;
  height: 64px;
  font-size: 24px;
  font-weight: 300;
  color: #ffffff;
  line-height: 32px;
  margin: 20px auto 0;
  text-align: center;
  text-shadow: 2px 2px gray;
}
.faq-bottom {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  margin: 0 auto;
  padding: 2rem 5rem 0 5rem;
}
.marginTop16 {
  margin-top: 15px;
}
.marginTop48 {
  margin-top: 48px;
}
.update-date {
  margin-top: 2vw;
  margin-bottom: 3vw;
  color: #aaa;
  font-size: 18px;
}
.policy-table {
  overflow-y: auto;
}
.policy-table-content {
  margin: 3vw 0 2vw;
  width: 100%;
  min-width: 800px;
  text-align: left;
  border-radius: 4px 4px 0 0;
  border-spacing: 0;
  border: 1px solid #e8e8e8;
  border-right: 0;
  border-bottom: 0;
}
.table-font-bold {
  font-weight: bold;
  color: #000000D9;
}
.ant-table-column-title {
  font-size: 16px;
}
.ant-table-tbody>tr>td, .ant-table-thead>tr>th {
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.ant-table-row {
  width: 30%;
}
.column-w-50 {
  width: 50%;
}
.column-w-25 {
  width: 25%;
}
@media only screen and (max-width: 600px){
.policy-container {
  padding: 0;
}
.policy-header {
  padding: 5vh 0;
  background-color: #163257;
}
.policy-title {
  padding: 1rem 2rem;
}
.title {
  font-size: 2rem;
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 2rem;
  margin-top: 7vw;
  text-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3);
}
.policy-content {
  padding: 6vw 2vw;
}
.policy-text {
  font-size: 16px;
}
.policy-content-title {
  font-size: 18px;
  line-height: 30px;
}
.title-border {
  padding-bottom: 10px;
  width: 50px;
}
.subTitle {
  width: 100%;
  height: auto;
  font-size: 1rem;
  font-weight: 400;
  color: #ffffff;
  padding: 0 5vw;
  line-height: 1.5rem;
  margin: 3vw auto 0;
  text-align: center;
}
.faq-bottom {
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 5vw;
}
.marginTop16 {
  margin-top: 3vw;
}
.marginTop48 {
  margin-top: 5vw;
}
.update-date {
  margin-top: 6vw;
  font-size: 16px;
}
}
</style>
